export default {
  QUERY: 'query',
  TAG: 'tag',
  CATEGORY: 'category',
};
